import React from "react";
import "./TxnLookup.css";

function PayoutModal({ modalData, setOpenModal }) {
  // console.log("model::::::::",modalData)
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{"Payment Details"}</h3>
        <div className="dialog-data">
          <p>
            <span>Beneficiary Name -</span>
            {modalData &&
              modalData.requestData &&
              modalData.requestData.beneName}
          </p>
          <p>
            <span>Amount -</span>₹
            {modalData && modalData.requestData && modalData.requestData.amount}
          </p>
          <p>
            <span>Beneficiary Mobile - </span>
            {modalData &&
              modalData.requestData &&
              modalData.requestData.beneMobile}
          </p>
          <p>
            <span>Beneficiary Email - </span>
            {modalData &&
              modalData.beneEmail &&
              modalData.requestData.beneEmail}
          </p>
          <p>
            <span>Beneficiary Bank Name - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.beneBankName}
          </p>
          <p>
            <span>Ifsc Code -</span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.ifscCode}
          </p>
          <p>
            <span>Account Number - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.accountNo}
          </p>
          <p>
            <span>Account Type -</span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.accountType}
          </p>
          <p>
            <span>Payment Mode -</span>{" "}
            {modalData && modalData.requestData && modalData.requestData.mode}
          </p>
          <p>
            <span>Order Id -</span>{" "}
            {modalData && modalData.orderId && modalData.orderId}
          </p>
          <p>
            <span>Transaction Id -</span>{" "}
            {modalData && modalData.transactionId && modalData.transactionId}
          </p>
        </div>

        <div className="modal-button">
          <button className="view-btn-1" onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default PayoutModal;
